"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loginTableName = exports.loginTableSchema = void 0;
const zod_1 = require("zod");
exports.loginTableSchema = zod_1.z.object({
    wizefiId: zod_1.z.string(),
    timestamp: zod_1.z.string().datetime()
});
exports.loginTableName = 'Login';
